import { createRouter, createWebHistory } from 'vue-router'

import MainHome from '@/components/home/MainHome.vue'
import MainDetails from '@/components/home/PropertyDetailsFigma.vue'
import MainIndex from '@/components/home/MainIndex.vue'
import MainHomeFilters from '@/components/home/PropertyListingFigma.vue'
import About from '@/components/About.vue'
import SupportPage from '@/components/SupportPage.vue'
import CatalogListing from '@/components/catalog/CatalogListing.vue'
import CatalogDetail from '@/components/catalog/CatalogDetail.vue'


const routes = [

  {
    path: '/',
    name: 'home',
    component: MainHome
  },

  {
    path: '/sobre',
    name: 'about',
    component: About
  },

  {
    path: '/suporte',
    name: 'suporte',
    component: SupportPage
  },

  {
    path: '/imovel/:slug',
    name: 'imovel-details',
    component: MainDetails
  },

  {
    path: '/imoveis/:objective',
    name: 'imoveis-index',
    component: MainIndex
  },

  {
    path: '/imoveis-search',
    name: 'imoveis-search',
    component: MainHomeFilters,

    props: (route) => ({
      location: route.query.location,
      objective: route.query.objective,
      property_type: route.query.property_type,
      condition: route.query.condition,
      bedroom_amount: route.query.bedroom_amount,
      max_price: route.query.max_price,
      bathroom_amount: route.query.bathroom_amount,
      garage_space: route.query.garage_space,
    })
  },

  {
    path: '/alojamentos',
    name: 'accommodations',
    component: CatalogListing,
    props: { kind: 'accommodation' }
  },
  {
    path: '/alojamentos/:slug',
    name: 'accommodation-detail',
    component: CatalogDetail,
    props: { kind: 'accommodation' }
  },
  {
    path: '/rent-a-car',
    name: 'rent-car',
    component: CatalogListing,
    props: { kind: 'rent' }
  },
  {
    path: '/rent-a-car/:slug',
    name: 'rent-car-detail',
    component: CatalogDetail,
    props: { kind: 'rent' }
  }

]


const router = createRouter({

  history: createWebHistory(process.env.BASE_URL),

  routes

})


export default router
